export default "__VITE_ASSET__dddf7a95__"